module.exports = __webpack_public_path__ + "img/cup-3.62fe276f.png";